import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import SettingsMenu from './SettingsMenu';

export default function Nav() {
  const { session, user, loading, signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate('/');
  }

  return (
    <nav>
      <Link to="/" className="brand">WatchWatch</Link>

      {/* Render nothing until the session is known, so the nav doesn't flash
          "Sign in" at someone who is already signed in. */}
      {!loading &&
        (session ? (
          <>
            <Link to="/watches">My Watches</Link>
            <span className="nav-email">{user?.email}</span>
            <button type="button" className="nav-link-btn" onClick={handleSignOut}>
              Sign out
            </button>
          </>
        ) : (
          <Link to="/signin">Sign in</Link>
        ))}

      {/* Last in the row and outside the auth branch: display settings are
          per-browser, so they apply just as much to a signed-out reader. */}
      <SettingsMenu />
    </nav>
  );
}
